import * as types from '../const/action.types';

export function rol(state = {}, action) {
    switch (action.type) {
        case types.LOAD_ROLE_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function roles_app(state = [], action) {
    switch (action.type) {
        case types.LOAD_APP_ROLES_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function roles(state = [], action) {
    switch (action.type) {
        case types.ROLES_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function rolesHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.ROLES_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function rolesIsLoading(state = false, action) {
    switch (action.type) {
        case types.ROLES_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/roles.reducer.js